module.exports = __webpack_public_path__ + "fonts/Inter-Regular.4dd66a1.woff2";